/** @format */

import { Col, Divider, Form, Select } from 'antd';
import { useGlobal } from 'reactn';

import { rulesValidation } from '../../../../../../components/Commons/Input/rules';
import { GlobalConsumer } from '../../../../../../components/Commons/Context/Global';

import { getPickupAvailableDays } from './get-pickup-available-days.util';
import '../DeliverySelect/style.scss';

export default function PickupDaySelect({ group, form }) {
	const [isRetirementData] = useGlobal('retirementData');
	const { isMobile } = GlobalConsumer();

	const specialSchedule = isRetirementData?.locals?.[0]?.special_schedule || [];

	const activeOverride = specialSchedule.find((sch) => sch && sch.status === true);
	const regularSchedule =
		activeOverride && activeOverride.original_daily_schedules
			? activeOverride.original_schedule
			: isRetirementData?.locals?.[0]?.schedule ?? [];

	const pickupDays = getPickupAvailableDays({
		specialSchedule,
		regularSchedule,
		count: 7,
	});

	if (!group) return null;

	return (
		<div className="ph-local-by-date-select-pharmacy-list-global-container">
			<div className="ph-local-by-date-select-pharmacy-list-main-container">
				<Col>
					<h4 className="ph-delivery-title">Seleccione día de retiro</h4>
				</Col>
				<Col>
					<div className="ph-local-by-date-select-pharmacy-list-delivery-select-container">
						<div>
							<Divider style={{ marginBottom: '7px', marginTop: '1px' }} />
							<h4 className="ph-withdrawal-delivery-day-title">Día de retiro:</h4>
							<Form.Item name={`date_schedule_${group.name}`} rules={rulesValidation.rulesDeliveryDate}>
								<Select
									className="ph-withdrawal-personal-data-field-selector"
									style={isMobile ? { width: '100%' } : { width: '60%' }}
									size="large"
									allowClear
									placeholder="Seleccionar"
									onChange={(value) => form?.setFieldsValue({ [`date_schedule_${group.name}`]: value })}
								>
									{pickupDays.map((day) => (
										<Select.Option value={day} key={day}>
											{day}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</div>
					</div>
				</Col>
			</div>
		</div>
	);
}
